import { EventEmitter, Injectable } from '@angular/core';
import { NGXLogger } from "ngx-logger";
import { BehaviorSubject } from 'rxjs';
import {
  CREATE_LOGIN_PATH,
  FUNDING_AVAILABLE_KEY,
  FUNDING_PATH,
  HOME_PATH,
  JOINT_MAINTENANCE_APPLICATION_PATH,
  JOINT_MAINTENANCE_CREATE_LOGIN_PATH,
  PROCESSING_PATH,
  REVIEW_PATH,
  SELECT_ACCOUNTS_PATH,
  TERMS_AND_DISCLOSURES_PATH
} from '../shared/constants';
import { Sections, SectionStates, SectionStatus } from "./model/section-status";
import { FacadeService } from '../shared/service-facade/facade.service';

@Injectable({
  providedIn: 'root'
})
export class SectionStatusService {
  get sectionsWithStatusTracker(): string[] {
    return [
      JOINT_MAINTENANCE_APPLICATION_PATH,
      SELECT_ACCOUNTS_PATH,
      HOME_PATH,
      REVIEW_PATH,
      TERMS_AND_DISCLOSURES_PATH,
      JOINT_MAINTENANCE_CREATE_LOGIN_PATH,
      PROCESSING_PATH,
      CREATE_LOGIN_PATH,
      FUNDING_PATH
    ];
  }

  private showCreateLogin: boolean = true;

  private statusTrackerSections: SectionStatus[] = [];
  public sectionChange = new EventEmitter<SectionStatus>();
  public sideNavDisplayChange = new EventEmitter<boolean>();
  public onTriggerValidations = new EventEmitter<void>();
  private _statusTrackerSections$: BehaviorSubject<SectionStatus[]> = new BehaviorSubject(this.statusTrackerSections);
  public statusTrackerSections$ = this._statusTrackerSections$.asObservable();

  constructor(private logger: NGXLogger, private facade: FacadeService) {
    let isMobile = window.screen.width <= 600;

    this.statusTrackerSections = [];

    this.statusTrackerSections.push(new SectionStatus(Sections.SelectAccounts, "Select Accounts", "select_accounts", SectionStates.notStarted, true));
    this.statusTrackerSections.push(new SectionStatus(Sections.YourApplication, "Your Information", "your_info", SectionStates.notStarted, true));
    this.statusTrackerSections.push(new SectionStatus(Sections.ReviewApplication, "Review Application", "review", SectionStates.notStarted, true));
    this.statusTrackerSections.push(new SectionStatus(Sections.TermsAndDisclosure, "Terms and Disclosures", "terms_and_disclosures", SectionStates.notStarted, true));
    this.statusTrackerSections.push(new SectionStatus(Sections.VerifyIdentification, "Verify Identity", "verify", SectionStates.notStarted, true));
    this.statusTrackerSections.push(new SectionStatus(Sections.CreateLogin, "Create Login", "create", SectionStates.notStarted, true));

    this._statusTrackerSections$.next(this.statusTrackerSections);
  }

  /**
   * Get all the tracker sections.
   */
  getStatusTrackerSections(): Array<SectionStatus> {
    return this.statusTrackerSections.slice();
  }

  /**
   * Get a named section
   * @param name The section requested or undefined if not found
   */
  getStatusTrackerSection(section: Sections): SectionStatus | undefined {
    return this.statusTrackerSections.find(s => s.section === section);
  }

  getSelectedSection(): string  {
    return this.statusTrackerSections.find(s => s.status === SectionStates.notStarted)?.description || '';
  }

  /**
   * Update a Status Trackersection with new status.
   * @param name Name of section.
   * @param status New state.
   */
  updateStatusTrackerSectionStatus(section: Sections, status: SectionStates, show: boolean = true) {
    let sectionStatus = this.getStatusTrackerSection(section);
    if (sectionStatus != undefined) {
      sectionStatus.status = status;
      sectionStatus.visible = show;
      this.logger.debug("Updating section status for " + section + ", status:" + JSON.stringify(sectionStatus));
      this.sectionChange.emit(sectionStatus);
    }

    this._statusTrackerSections$.next(this.statusTrackerSections);
  }

  removeStatusTrackerSection(section: Sections) {
    this.statusTrackerSections = this.statusTrackerSections.filter(s => s.section !== section);
    this._statusTrackerSections$.next(this.statusTrackerSections);
  }

  triggerValidation(): void {
    this.onTriggerValidations.emit();
  }
}
